import { render, staticRenderFns } from "./PacientesDetalleCitas.vue?vue&type=template&id=760b84db&"
import script from "./PacientesDetalleCitas.vue?vue&type=script&lang=js&"
export * from "./PacientesDetalleCitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports